import IconInfoBasic from "@resources/images/IconInfoBasic.svg";
import styled from "styled-components";

export const StyledInfoIcon = styled(IconInfoBasic)`
  width: 18px;
  height: 18px;
  fill: #a9a5a6;
`;
